var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LucidLinkConnectSvg from './lucid-link-connect.icon.svg';
export const LucidLinkConnectIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LucidLinkConnectSvg }));
_react_refresh_temp_1 = LucidLinkConnectIcon;
$RefreshReg$(_react_refresh_temp_1, "LucidLinkConnectIcon");
